import { RoutePaths } from "@/core/constants/RoutePaths";
import type { APIResponseBFFData } from "@superagents/types/api/api.v5";
import {
  getOnboardingV2ResumePath,
  isOnboardingV2FinalStepPersisted,
  isOnboardingV2InProgress,
} from "@/features/onboarding-v2/utils/storage";

type AuthUser = APIResponseBFFData<"bff::user"> | undefined;

export function getPublicOnlyRedirect(
  isLoggedIn: boolean,
  user: AuthUser
): string | null {
  if (!isLoggedIn) return null;

  const resumePath = getOnboardingV2ResumePath(user?.documentId);
  if (resumePath && isOnboardingV2InProgress(user?.documentId)) {
    return resumePath;
  }

  const hasSector = Boolean(user?.sectorId);
  if (!hasSector) return RoutePaths.ONBOARDING;

  return RoutePaths.CHATS;
}

export function getProtectedRedirect(
  isLoggedIn: boolean,
  user: AuthUser,
  currentPath: string
): string | null {
  if (!isLoggedIn) return RoutePaths.LOGIN;

  const resumePath = getOnboardingV2ResumePath(user?.documentId);
  const isOnboardingInProgress = isOnboardingV2InProgress(user?.documentId);
  const isOnboardingPath = currentPath === RoutePaths.ONBOARDING;

  if (isOnboardingInProgress) {
    if (isOnboardingPath) {
      return null;
    }

    return resumePath ?? RoutePaths.ONBOARDING;
  }

  const hasSector = Boolean(user?.sectorId);

  if (!hasSector && !isOnboardingPath) {
    return RoutePaths.ONBOARDING;
  }

  if (hasSector && isOnboardingPath) {
    if (isOnboardingV2FinalStepPersisted()) {
      return null;
    }

    return RoutePaths.CHATS;
  }

  return null;
}
